// keys the api sends on every translation, they do not hold any user content
const METADATA_KEYS = ['@id', '@type', 'id', 'locale'];

// tells if the user filled anything in a translation, `ignoredField` allows to check
// the other fields only (e.g. "is the description filled while the name is empty ?")
export default function hasTranslationContent(translation, ignoredField = null) {
    return Object.entries(translation || {})
        .filter(([key]) => key !== ignoredField && !METADATA_KEYS.includes(key))
        .some(([, value]) => typeof value === 'string' ? value.trim() !== '' : Boolean(value));
}
